import React from "react";
import { Col, Dropdown } from "react-bootstrap";
import { CirclePicker } from "react-color";

const colorPicker = ({ label, col, classC, description, lstColors, handleChange }) => {

    return (
        <Col xs={col}>
            <label>{label}</label>
            <Dropdown>
                <Dropdown.Toggle className="btn btn-colores" variant="default">
                    <span className={`dot ${classC}`}></span> {description}
                </Dropdown.Toggle>
                <Dropdown.Menu className="colores">
                    <CirclePicker
                        colors={lstColors}
                        onChange={handleChange}
                    />
                </Dropdown.Menu>
            </Dropdown>
        </Col>
    );
}

export default colorPicker;